import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    customers: `${APP_CONFIG.apigee_host}/masmovil/v1/customers`,
  },
}
